<template>
    <div class="animated fadeIn">
       <b-modal
        title="Edit"
        class="modal-primary"
        v-model="modalEdit"
        @ok="updateData(), modalEdit = false"
      >
         <b-row> 
          <b-col lg="6">
            <b-form-input v-model="companyEdit" placeholder="Company" style="height:45px;" class="mb-2"></b-form-input>
          </b-col>
          <b-col lg="6">
            <b-form-input v-model="contactEdit" placeholder="Contact Name" style="height:45px;" class="mb-2"></b-form-input>
          </b-col>
          <b-col lg="6">
            <b-form-input v-model="phoneEdit" placeholder="Phone Number" style="height:45px;" class="mb-2"></b-form-input>
          </b-col>
          <b-col lg="6">
            <b-form-input v-model="addressEdit" placeholder="Address" style="height:45px;" class="mb-2"></b-form-input>
          </b-col>
          <b-col lg="6">
            <b-form-input v-model="locationEdit" placeholder="City" style="height:45px;" class="mb-2"></b-form-input>
          </b-col>
          <b-col lg="3">
            <b-form-input v-model="stateEdit" placeholder="State" style="height:45px;" class="mb-2"></b-form-input>
          </b-col>
          <b-col lg="3">
            <b-form-input v-model="zipEdit" placeholder="Zip" style="height:45px;" class="mb-2"></b-form-input>
          </b-col>
          <b-col lg="12">
            <b-form-textarea
              id="textarea"
              v-model="commentEdit"
              placeholder="Comment"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
       </b-modal>
        <b-row>
            <b-col lg="12">
                <b-card class="information" header="data">
                    <div slot="header">
                        <h5 style="display: inline;" class="card-title mb-0">Add New</h5>
                    </div>
                    <div style="">
                      <b-row> 
                        <b-col lg="4">
                          <b-form-input v-model="company" placeholder="Company" style="height:45px;" class="mb-2"></b-form-input>
                        </b-col>
                        <b-col lg="4">
                          <b-form-input v-model="contact" placeholder="Contact Name" style="height:45px;" class="mb-2"></b-form-input>
                        </b-col>
                        <b-col lg="4">
                          <b-form-input v-model="phone" placeholder="Phone Number" style="height:45px;" class="mb-2"></b-form-input>
                        </b-col>
                        <b-col lg="4">
                          <b-form-input v-model="address" placeholder="Address" style="height:45px;" class="mb-2"></b-form-input>
                        </b-col>
                        <b-col lg="4">
                          <b-form-input v-model="location" placeholder="City" style="height:45px;" class="mb-2"></b-form-input>
                        </b-col>
                        <b-col lg="2">
                          <b-form-input v-model="state" placeholder="State" style="height:45px;" class="mb-2"></b-form-input>
                        </b-col>
                        <b-col lg="2">
                          <b-form-input v-model="zip" placeholder="Zip" style="height:45px;" class="mb-2"></b-form-input>
                        </b-col>
                        <b-col lg="12">
                          <b-form-textarea
                            id="textarea"
                            v-model="comment"
                            placeholder="Comment"
                            rows="3"
                            max-rows="6"
                          ></b-form-textarea>
                        </b-col>
                        <b-col lg="12">
                            <b-button variant="outline-primary" @click="sendData" style="display:block; margin:auto;  margin-top:30px; height:40px; width:130px">Submit</b-button>
                        </b-col>
                      </b-row>
                    </div>
                </b-card>
            </b-col>

             <b-col lg="12">
                <b-card class="information" header="data">
                    <div slot="header">
                        <b-row>
                          <b-col lg="8">
                            <h5 style="display: inline;" class="card-title mb-0">Sales Rep</h5>
                          </b-col>
                          <b-col lg="4" >
                            <b-input-group size="sm">
                              <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="Type to Search"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-col>
                        </b-row>
                    </div>
                    <div style="">
                      <b-table :filter="filter" :fields="fields" size="lg" :items="items">
                        <template v-slot:cell(edit)="data">
                           <b-button variant="outline-primary" @click="openEdit(data.item)"><i class="fa fa-edit" style="color: white;" aria-hidden="true"></i></b-button>
                        </template>
                      </b-table>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
  name: "model",
  components: {},
  data: function() {
    return {
      loadingData: true,
      filter: null,
      modalEdit: false,
      id: "",
      companyEdit: "",
      locationEdit: "",
      addressEdit: "",
      contactEdit: "",
      stateEdit: "",
      phoneEdit: "",
      zipEdit: "",
      commentEdit: "",
      company: "",
      location: "",
      address: "",
      contact: "",
      state: "",
      phone: "",
      zip: "",
      comment: "",
      items: [],
      fields: [
        { key: "date", label: "Date" },
        { key: "company", label: "Company" },
        { key: "contact", label: "Contact Name" },
        { key: "phone_no", label: "Phone Number" },
        { key: "city", label: "City" },
        { key: "address", label: "Address" },
        { key: "zip", label: "Zip" },
        { key: "comment", label: "Comment" },
        { key: "edit", label: "Edit" }
      ],
    };
  },
  methods: {
    openEdit(data) {
      console.log(data);
      this.id = data.id;
      this.companyEdit = data.company;
      this.locationEdit = data.city;
      this.addressEdit = data.address;
      this.contactEdit = data.contact;
      this.stateEdit = data.state;
      this.phoneEdit = data.phone_no;
      this.zipEdit = data.zip;
      this.commentEdit = data.comment;
      this.modalEdit = true;
    },
    updateData() {
       let formData = new FormData();
      
      formData.append("id", this.id);

      formData.append("company", this.companyEdit);
      formData.append("contact", this.contactEdit);
      formData.append("phone", this.phoneEdit);

      formData.append("address", this.addressEdit);
      formData.append("location", this.locationEdit);
      formData.append("state", this.stateEdit);
      formData.append("zip", this.zipEdit);

      formData.append("comment", this.commentEdit);

      this.$http
         .post(
              "api/alpha/sales/editSale.php",
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }
            )
        .then(
          res => {
            console.log(res.data);
            this.fetchData()
          },
          err => {
            console.log(err);
          }
        );
    },
    sendData() {
      let formData = new FormData();
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      
      formData.append("date", dateTime);

      formData.append("company", this.company);
      formData.append("contact", this.contact);
      formData.append("phone", this.phone);

      formData.append("address", this.address);
      formData.append("location", this.location);
      formData.append("state", this.state);
      formData.append("zip", this.zip);

      formData.append("comment", this.comment);
      formData.append("user", localStorage.getItem("alpha_user"));

      this.$http
         .post(
              "api/alpha/sales/addSale.php",
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }
            )
        .then(
          res => {
            console.log(res.data);
            this.fetchData()
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        user: localStorage.getItem("alpha_user")
      };
      this.$http
        .get("api/alpha/sales/SalesPreview.php", {
          params
        })
        .then(
          res => {
            this.items = res.data
            console.log(res);
          },
          err => {
            this.loadingData = false;
            console.log(err);
          });}
  },
  mounted() {
    this.fetchData()
  }
};
</script>

<style>
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
